// extracted by mini-css-extract-plugin
export default {"body":"loading_body__x+4Sx","container":"loading_container__hkTfB","scale":"loading_scale__Jo0fK","loader":"loading_loader__VOTUX","rotate":"loading_rotate__VpXcF"};